export default {
    props: {

        // A boolean to state whether a medium shadow shall be shown or a specific shadow size string
        shadow: {
            type: [String, Boolean],
            default: null
        },

        // Whether to prevent any shadow
        flat: {
            type: Boolean,
            default: false
        },

        // Whether to display a small shadow
        shadowSmall: {
            type: Boolean,
            default: false
        },

        // Whether to display a medium shadow
        shadowMedium: {
            type: Boolean,
            default: false
        },

        // Whether to display a large shadow
        shadowLarge: {
            type: Boolean,
            default: false
        }
    },

    computed: {
        shadowString() {
            if (this.flat || this.shadow === false) {
                return null;
            }

            if (this.shadowSmall) {
                return 'sm';
            }

            if (this.shadowMedium) {
                return 'md';
            }

            if (this.shadowLarge) {
                return 'lg';
            }

            return [true, 'true', ''].indexOf(this.shadow) > -1 ? 'sm' : this.shadow;
        }
    }
}
